import FlightsCarsPackagesCarouselContainer from '../../../../components/containers/FlightsCarsPackagesCarouselContainer';
import deepmerge from '../../../utils/deepmerge';
import preloadCustomProps from '../../../utils/preloads/preloadFaresFlightsCarsPackagesGrid';

const cmpConfig = {
  name: 'flights-cars-packages-carousel',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: FlightsCarsPackagesCarouselContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
